import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import NumberFormat from "react-number-format";
import mainSubLogo from "../../../../../img/signature_icon.png";
import SubscriptionCard from "./subscription-card";
import {
  changeCompanyModal,
  setActiveSubscription,
} from "../../../../../redux/actions/company";
import { changeUniversalModal } from "../../../../../redux/actions/universal";
import { TableLoader } from "../../../../library/table-loader";
import { UpperRow } from "../../../../library/upper-row";
import "./style.scss";
import { FadeButton, SolidButton } from "../../../../library/button";

const Index = () => {
  const dispatch = useDispatch();

  const main = useSelector((state) => state.company.subscription?.main);
  const other = useSelector((state) => state.company.subscription?.other);
  const loading = useSelector(
    (state) => state.company.fetchSubscription.loading
  );

  const activeCompany = useSelector(
    (state) =>
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const companyDetailsLoading = useSelector(
    (state) => state.company.fetchDetails.loading
  );

  const clickRemoveSubscription = (id, type) => {
    dispatch(setActiveSubscription({ id: id, type: type, channels: null }));
    dispatch(changeCompanyModal({ cancelSubscription: true }));
  };

  const clickChangeMainSubscription = () => {
    dispatch(changeCompanyModal({ changeMainSubscription: true }));
  };

  const clickResubscribe = () => {
    dispatch(changeUniversalModal({ resubscribeModal: true }));
  };

  return (
    <div className="dashboard-company-payments-container">
      <div className="inner-dashboard-company-payments-container">
        <UpperRow title="Hovedabonnement" />
        <div className="subscription-details-container">
          {!loading && main && Object.keys(main).length > 0 ? (
            <div className="main-subscription-container highlight">
              <div className="inner-main-subscription-container">
                <Row className="subscription-row">
                  <Col className="icon-col my-auto text-left">
                    <img className="logo" src={mainSubLogo} />
                  </Col>
                  <Col className="license-col my-auto text-left">
                    <h2 className="card-title">Standard tilgang</h2>
                    <p className="card-description">
                      x{main.quantity} lisens(er)
                    </p>
                  </Col>
                  <Col className="trial-col my-auto text-left">
                    <h2 className="card-title">Prøveperiode</h2>
                    <p className="card-description">
                      {main.trialDays
                        ? `${main.trialDays} dager igjen`
                        : "Ingen dager igjen"}
                    </p>
                  </Col>
                  <Col className="price-col my-auto text-center">
                    <h2 className="card-title">
                      <NumberFormat
                        displayType={"text"}
                        thousandSeparator={" "}
                        value={main.price / 100}
                      />
                      kr
                    </h2>
                    <p className="card-description">per måned</p>
                  </Col>
                  <Col className="button-col my-auto">
                    <FadeButton
                      onClick={() => clickChangeMainSubscription()}
                      size="md"
                      title="Endre"
                      spacing="right"
                      color="blue"
                    />
                    <FadeButton
                      onClick={() => clickRemoveSubscription(main.id, "main")}
                      size="md"
                      title="Slett"
                      spacing="right"
                      color="blue"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}
          {!loading && Object.keys(main).length === 0 ? (
            <div className="empty-subscription-container highlight">
              <div className="inner-empty-subscription-container">
                <h2 className="empty-title">Ikke aktivt abonnement</h2>
                <p className="empty-description">
                  Du har ikke et aktivt abonnement, men du kan starte et nytt et
                  ved å trykke på knappen under.
                </p>
                <SolidButton
                  onClick={() => clickResubscribe()}
                  color="blue"
                  title="Start nytt abonnement"
                />
              </div>
            </div>
          ) : null}
          {loading && <TableLoader />}
        </div>
        <UpperRow title="Tilleggsabonnementer" />
        <div className="subscription-details-container">
          {other &&
            other.map((single, i, arr) => {
              return (
                <SubscriptionCard
                  subscription={single}
                  last={i === arr.length - 1 ? true : false}
                />
              );
            })}
          {!loading && !companyDetailsLoading && other && other.length === 0 ? (
            <div className="empty-subscription-container">
              <div className="inner-empty-subscription-container">
                <h2 className="empty-title highlight">
                  Ingen tilleggsabonnementer
                </h2>
                <p className="empty-description">
                  Du må først opprette et nytt hovedabonnement før du kan
                  abonnere på tilleggstjenester.
                </p>
              </div>
            </div>
          ) : null}
          {loading && <TableLoader />}
        </div>
      </div>
    </div>
  );
};

export default Index;
